export default "__VITE_ASSET__3gY2Rs$s__"